import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';
import {
	EventService,
	GoEvent
} from '@go-modules/services/event/event.service';
import { mediaPreviewToken } from 'go-modules/modals/media-preview/modal.factory';
import { TranslateModule } from '@ngx-translate/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxMediaThumbnailModule } from '@go-modules/components/media-thumbnail/media-thumbnail.module';
import { Action } from '@go-modules/components/toolbar/toolbar-button/action-to-icon-class-map';
import { PanelModule } from '@go-modules/components/panel/panel.module';
import { NgxToolbarModule } from '@go-modules/components/toolbar/toolbar.module';
import { NgxToolbarButtonModule } from '@go-modules/components/toolbar/toolbar-button/toolbar-button.module';

@Component({
	selector: 'ngx-source-media-panel',
	standalone: true,
	imports: [
		CommonModule,
		PanelModule,
		NgxToolbarModule,
		NgxToolbarButtonModule,
		TranslateModule,
		NgxMediaThumbnailModule
	],
	templateUrl: './source-media-panel.component.html',
	styleUrls: ['./source-media-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NgxSourceMediaPanelComponent implements OnInit, OnDestroy {
	@Input() public sourceMedia: any;
	@Input() public groupId: number;

	@Output() public onRemove = new EventEmitter<void>();
	@Output() public onMediaSync = new EventEmitter<any>();

	protected readonly Action = Action;
	private eventSubscription?: Subscription;

	constructor (
		private eventService: EventService,
		@Inject(mediaPreviewToken) private mediaPreviewModal
	) {}

	public ngOnInit (): void {
		this.eventSubscription = this.eventService.events
			.pipe(filter((ev: GoEvent) => ev.name === EVENT_NAMES.MEDIA_SYNC))
			.subscribe((ev: GoEvent) => {
				if (
					this.sourceMedia?.media &&
					parseInt(this.sourceMedia.media.media_id, 10) === parseInt(ev.data.media_id, 10)
				) {
					const sourceMedia = structuredClone(this.sourceMedia);
					this.onMediaSync.emit(Object.assign(sourceMedia.media, ev.data));
				}
			});
	}

	public ngOnDestroy (): void {
		this.eventSubscription?.unsubscribe();
	}

	public openMediaPreviewModal (edit: boolean) {
		const modalData = {
			media: this.sourceMedia.media,
			edit,
			allowDownload: true,
			groupId: this.groupId
		};

		return this.mediaPreviewModal.open({ modalData }).result;
	}
}
